import type { GlassBackgroundProps } from './Glass.types';

/**
 * Frosted-glass layer — WEB is a no-op. The browser renders Figma's "Glass"
 * effect with a real CSS `backdrop-filter` (`web:backdrop-blur-[Npx]`) on the
 * surface element itself, clipped by its own `overflow-hidden` + radius.
 * React Native has no `backdrop-filter`, which is what the `.native` sibling
 * is for.
 */
export function GlassBackground(_props: GlassBackgroundProps): null {
  return null;
}
GlassBackground.displayName = 'GlassBackground';
